<div class="card" [class.increase]="cardInfo.shareStatus === 'increase'"
  [class.decrease]="cardInfo.shareStatus === 'decrease'" (click)="clickBtn && clickBtn()"
  *transloco="let t; prefix: 'fuelShared'">
  <div class="card-body p-4">
    <div class="card-box-wrap d-flex justify-content-between">
      <div class="card-left">
        <div class="img d-flex align-items-center justify-content-center">
          <img [src]="cardInfo.iconImg" alt="icon">
        </div>
        <h4>{{ cardInfo.title }}</h4>

        <div class="selected-box">
          @if(cardInfo.isSelect){
          <div class="common-drop-down dropdown">
            <button type="button" id="dropdown-button" data-bs-toggle="dropdown" aria-expanded="false"
              (click)="$event.stopPropagation(); $event.preventDefault();">
              {{ cardInfo.selectInitialValue ? cardInfo.selectInitialValue : '40 ℓ/km' }}
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdown-button">
              <li><a class="dropdown-item">{{ t('card.litres') }}</a></li>
              <li>
                <a class="dropdown-item">{{ t('card.litresPerKilometer') }}</a>
              </li>
              <li>
                <a class="dropdown-item">{{ t('card.litresPer100km') }}</a>
              </li>
              <li>
                <a class="dropdown-item">{{ t('card.randsPerLitre') }}</a>
              </li>
            </ul>
          </div>
          }@else {
          <h5>{{cardInfo.status || ''}}</h5>
          }
        </div>
      </div>

      <div class="card-right d-flex justify-content-between flex-column align-items-end">
        <div class="img d-flex align-items-center justify-content-center">
          <img [src]="cardInfo.iconImg2" alt="icon">
        </div>
        <p>{{ cardInfo.percentage }}</p>
      </div>
    </div>

    @if (cardInfo.isFooter) {
    <div class="down-card">
      <h4>
        {{ footerInfo.currency }}
        <strong>{{ footerInfo.currencyStatus }}</strong>
      </h4>
    </div>
    }

  </div>
</div>